import { render } from "./DynamicSelect.vue?vue&type=template&id=2dfbabe3&ts=true"
import script from "./DynamicSelect.vue?vue&type=script&lang=ts"
export * from "./DynamicSelect.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__